/* ============================================================================
   mypka-laufschrift.js — Pausensteuerung fuer alle Laufschriften des Themes.
   Angelegt 22.08.2026 (Felix), Reparatur zu QA-Befund C1/N1 (Vera, 22.08.).
   WCAG 2.2 · 2.2.2 Pause, Stop, Hide (Level A).

   Vertrag:
   - Zustand lebt als data-mypka-bewegung="an|aus" am <html>. Ein Zustand fuer
     alle Laufschriften der Seite — zwei Baender, die man einzeln anhalten muss,
     sind keine Steuerung, sondern eine Aufgabe.
   - Das eigentliche Anhalten macht CSS (animation-play-state), nicht JS.
     JS setzt nur das Attribut und den zugaenglichen Namen.
   - Auswahl bleibt in localStorage ('mypka-bewegung'), damit ein Klick nicht
     bei jedem Seitenwechsel verfaellt.
   - Bei prefers-reduced-motion steht ohnehin alles still (CSS), die Steuerung
     ist dann per CSS ausgeblendet; wir fassen den Zustand hier nicht an.
   ========================================================================== */
(function () {
	'use strict';

	var SCHLUESSEL = 'mypka-bewegung';
	var WURZEL = document.documentElement;
	var LABEL_ANHALTEN = 'Laufschrift anhalten';
	var LABEL_WEITER = 'Laufschrift fortsetzen';

	function lesen() {
		try {
			return window.localStorage.getItem(SCHLUESSEL);
		} catch (e) {
			return null;
		}
	}

	function schreiben(wert) {
		try {
			window.localStorage.setItem(SCHLUESSEL, wert);
		} catch (e) {
			/* Private Mode o. ae. — der Zustand gilt dann nur fuer diese Seite. */
		}
	}

	function knoepfe() {
		return document.querySelectorAll('[data-mypka-laufschrift-knopf]');
	}

	function anwenden(zustand) {
		WURZEL.setAttribute('data-mypka-bewegung', zustand);
		var aus = zustand === 'aus';
		Array.prototype.forEach.call(knoepfe(), function (knopf) {
			var label = aus ? LABEL_WEITER : LABEL_ANHALTEN;
			knopf.setAttribute('aria-label', label);
			knopf.setAttribute('title', label);
		});
	}

	function umschalten() {
		var neu = WURZEL.getAttribute('data-mypka-bewegung') === 'aus' ? 'an' : 'aus';
		anwenden(neu);
		schreiben(neu);
	}

	function init() {
		if (!knoepfe().length) return;
		anwenden(lesen() === 'aus' ? 'aus' : 'an');
		Array.prototype.forEach.call(knoepfe(), function (knopf) {
			if (knopf.dataset.mypkaGebunden === '1') return;
			knopf.dataset.mypkaGebunden = '1';
			knopf.addEventListener('click', umschalten);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	/* Theme-Editor: Sektionen werden nachgeladen. */
	document.addEventListener('shopify:section:load', init);
})();
